export type LeadTransitionAction = {
  to: string;
  label: string;
  type?: 'primary' | 'default';
  danger?: boolean;
};

export const transitionOptions: Record<string, LeadTransitionAction[]> = {
  NOT_CONTACTED: [
    { to: 'CONTACTED_FOLLOW_UP', label: 'Marker som kontaktet', type: 'primary' },
    { to: 'CONTACTED_NOT_RELEVANT', label: 'Ikke relevant', danger: true }
  ],
  CONTACTED_FOLLOW_UP: [
    { to: 'NEEDS_ASSESSMENT', label: 'Behov afdækket', type: 'primary' },
    { to: 'CONTACTED_NOT_RELEVANT', label: 'Ikke relevant', danger: true }
  ],
  NEEDS_ASSESSMENT: [
    { to: 'AWAITING_MATERIAL', label: 'Afventer materiale', type: 'primary' },
    { to: 'ANALYSIS_MARKET', label: 'Til analyse/marked' },
    { to: 'CONTACTED_NOT_RELEVANT', label: 'Ikke relevant', danger: true }
  ],
  AWAITING_MATERIAL: [
    { to: 'ANALYSIS_MARKET', label: 'Til analyse/marked', type: 'primary' },
    { to: 'NEEDS_ASSESSMENT', label: 'Tilbage til behov' },
    { to: 'CONTACTED_NOT_RELEVANT', label: 'Ikke relevant', danger: true }
  ],
  ANALYSIS_MARKET: [
    { to: 'AGREEMENT_MADE', label: 'Agreement made', type: 'primary' },
    { to: 'AWAITING_MATERIAL', label: 'Tilbage til materiale' },
    { to: 'CONTACTED_NOT_RELEVANT', label: 'Ikke relevant', danger: true }
  ],
  AGREEMENT_MADE: [
    { to: 'CUSTOMER_ACTIVE', label: 'Kunde aktiv', type: 'primary' },
    { to: 'ANALYSIS_MARKET', label: 'Tilbage til analyse' },
    { to: 'CUSTOMER_LOST', label: 'Kunde tabt', danger: true }
  ],
  CUSTOMER_ACTIVE: [
    { to: 'CUSTOMER_LOST', label: 'Kunde tabt', danger: true },
    { to: 'AGREEMENT_MADE', label: 'Tilbage til agreement' }
  ],
  CUSTOMER_LOST: [{ to: 'CUSTOMER_ACTIVE', label: 'Genåbn kunde', type: 'primary' }],
  CONTACTED_NOT_RELEVANT: [{ to: 'CONTACTED_FOLLOW_UP', label: 'Genåbn som opfølgning', type: 'primary' }]
};
